export const DATABASE_NAME = 'real-maquinas-inspecao'
export const DATABASE_SCHEMA_VERSION = 8
export const INSPECTION_SCHEMA_VERSION = 4
